import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import MenuIcon from '@mui/icons-material/Menu';
import { IconButton, Typography, Divider } from '@mui/material';
import { ArrowBackIosNew } from '@mui/icons-material';
import MenuItem from './MenuItem';
import checkAuthController from '../controllers/check-auth.controller';
import { UserInfoModel } from '../../../pages/user/models/user.model';

export default function MobileDrawer() {
  const checkUser = checkAuthController();
  const [state, setState] = React.useState(false);
  React.useEffect(() => {
    checkUser.getLoginUser();
  }, []);

  const user: UserInfoModel | null = checkUser.loginUser;
  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    setState(open);
  };

  const list = () => (
    <Box
      sx={{ width: 260, paddingLeft: '20px', paddingRight: '20px', paddingTop: '20px' }}
      role="presentation"
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography fontSize={26}>MSEG Flow</Typography>
          <IconButton onClick={toggleDrawer(false)}>
            <ArrowBackIosNew
              sx={{
                color: 'black',
                fontSize: 20,
                backgroundColor: '#E0E0E0',
                p: 0.5,
                borderRadius: 30,
              }}
            />
          </IconButton>
        </Box>
        <Box>
          <MenuItem user={user} onPressed={() => setState(false)} />
        </Box>
        <Box flex={1} display={'flex'} marginBottom={'20px'} />
        <Divider sx={{ marginBottom: '20px' }} />
        <Typography style={{ fontSize: 13, marginBottom: '10px', color: '#486BC2' }}>
          Support by Sivilltech co.,ltd
        </Typography>
      </List>
    </Box>
  );

  return (
    <div>
      <React.Fragment key={'anchor'}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          color="inherit"
        >
          <MenuIcon sx={{ color: 'white' }} onClick={toggleDrawer(true)} />
        </IconButton>
        <Drawer anchor={'left'} open={state} onClose={toggleDrawer(false)}>
          {list()}
        </Drawer>
      </React.Fragment>
    </div>
  );
}
